export default {"gitHash":"9642b93da51f9b8467814daba4d12070a05ba92b","gitHashShort":"9642b93","time":1650112220624,"platform":"linux","arch":"x64"};